import { Component, OnInit, ViewChild } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { SaleOrderService } from "../../../../core/services/sale-order.service";
import { Router, NavigationExtras, ActivatedRoute } from "@angular/router";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { map } from "rxjs";
import { ApplyCreditCard } from "../../../../core/models/orders/applyCreditCard";
import { CreateSalesOrderRequestDto } from "../../../../core/models/orders/createSalesOrderRequestDto";
import { CustomerPaymentMethodDto } from "../../../../core/models/orders/customerPaymentMethodDto";
import { GetBacForSalesOrderDto } from "../../../../core/models/orders/getBacForSalesOrderDto";
import { GetBCForSalesOrderDto } from "../../../../core/models/orders/getBCForSalesOrderDto";
import { InvoicedEmailDto } from "../../../../core/models/orders/invoicedEmailDto";
import { SalesOrderNotes } from "../../../../core/models/orders/salesOrderNotes";
import { ValidateLogin } from "../../../../core/models/validate-login.dto";
import { LoaderService } from "../../../../core/services/loader.service";
import { OrderHeaderComponent } from "../../ui/order-header/order-header.component";
import { OrderNotesSidebarService } from "../../../../core/services/order-notes-sidebar.service";
import { v4 as uuidv4 } from "uuid";
import { UserManagementService } from "../../../../core/services/user-management.service";
import { Contact } from "../../../../core/models/shared/contact";
import { AddressCountryRegion } from "../../../../core/models/shared/countryRegionList";
import { Currency } from "../../../../core/models/shared/currencyList";
import { ShippingMethod } from "../../../../core/models/shared/shippingMethod";
import { AddNewClientService } from "../../../../core/services/add-new-client.service";
import { SamplepoListingService } from "../../../../core/services/samplepo-listing.service";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { CustomerAccountService } from "../../../../core/services/customer-account.service";
import { ClientSearchList } from "../../../../core/models/shared/clientSearchList";
import { EnumContactType } from "../../../../shared/enums/enumContactType";
import { ClientDetailsService } from "../../../../core/services/client-details.service";
import { GetD365DefaultProgramsAndSalesClassificationByClientResponse } from "../../../../core/models/program/getD365DefaultProgramsAndSalesClassificationByClientResponse";
import { ProgramClientListDto } from "../../../../core/models/program/programClientListDto";
import { ProgramsService } from "../../../../core/services/programs.service";
import { ShipToAddressComponent } from "../../../../shared/components/ship-to-address/ship-to-address.component";
import { CustomerAddressComponent } from "../../ui/customer-address/customer-address.component";
import { InvoiceEmailsComponent } from "../invoice-emails/invoice-emails.component";
import { OrderDetailsComponent } from "../../ui/order-details/order-details.component";
import { ProfileFormService } from "../../../../core/services/profile-form.service";
import { CommonModule } from "@angular/common";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";
import { UsersList } from "../../../../core/models/users/users/usersList";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { CheckboxModule } from "primeng/checkbox";
import { ToggleSwitchModule } from "primeng/toggleswitch";
import { ButtonModule } from "primeng/button";
import { SpinnerComponent } from "../../../../shared/components/spinner/spinner.component";
import { GetUserProjectDto } from "../../../../core/models/samplePO/details/getUserProjectDto";
import { ClientAddressCustomize } from "../../../../core/models/client/details/clientAddresscustomize";
import { ClientContact } from "../../../../core/models/client/details/clientContact";

@UntilDestroy()
@Component({
  selector: "jni-sale-order",
  templateUrl: "./sale-order.component.html",
  styleUrls: ["./sale-order.component.scss"],
  imports: [
    OrderHeaderComponent,
    CustomerAddressComponent,
    ShipToAddressComponent,
    InvoiceEmailsComponent,
    OrderDetailsComponent,
    ReactiveFormsModule,
    CommonModule,
    CardModule,
    InputTextModule,
    CheckboxModule,
    ToggleSwitchModule,
    ButtonModule,
    SpinnerComponent,
  ],
})
export class SaleOrderComponent implements OnInit {
  showSmallLoader = false;
  invoiceListing: {
    id: number;
    name: string;
    purpose: string;
    email: string;
  }[] = [
    {
      id: 1,
      name: "Linda Brigs",
      purpose: "Accounts Payable",
      email: "megan@teslamotors.com",
    },
    {
      id: 2,
      name: "Linda Brigs",
      purpose: "Accounts Payable",
      email: "megan@teslamotors.com",
    },
    {
      id: 3,
      name: "Linda Brigs",
      purpose: "Accounts Payable",
      email: "megan@teslamotors.com",
    },
  ];
  saleOrderForm!: FormGroup;
  clientCurrencyValue = "USD";
  brandingConsultantLists: GetBCForSalesOrderDto[] = [];
  addressBookName = "";
  vendorAccountNumber = "";
  brandingConsultantObject!: GetBCForSalesOrderDto;
  bcList: UsersList[] = [];
  bacList: GetBacForSalesOrderDto[] = [];
  bacUserDefaultSelectionId = "";
  currencyList: Currency[] = [];
  shippingProductsList: ShippingMethod[] = [];
  countryRegionList: AddressCountryRegion[] = [];
  customerBillToObject!: ClientSearchList;
  clientContacts: Contact[] = [];
  customerPaymentMethodList: CustomerPaymentMethodDto[] = [];
  userPersonnelNumber!: string;
  avaiableCredit = 0;
  isCustomerPoRequiredField = false;
  redirectedFromWorkflow = false;
  orderType = "";
  getD365DefaultProgramsAndSalesClassification =
    {} as GetD365DefaultProgramsAndSalesClassificationByClientResponse;

  deliveryAddress = [
    {
      id: 1,
      name: "One Time",
      status: false,
    },
    {
      id: 2,
      name: "Bill To",
      status: true,
    },
    {
      id: 3,
      name: "Client Address Book",
      status: true,
    },
    {
      id: 4,
      name: "Multi Ship To",
      status: false,
    },
    {
      id: 5,
      name: "TBD",
      status: false,
    },
  ];
  applyCreditCardList: ApplyCreditCard[] = [
    {
      id: 0,
      name: "Client",
    },
    {
      id: 1,
      name: "BC Ledger",
    },
  ];

  @ViewChild("shipTo", { static: false })
  shipTo!: ShipToAddressComponent;
  customerAccountNumber = "";

  @ViewChild("orderHeader", { static: false })
  orderHeader!: OrderHeaderComponent;

  @ViewChild("orderDetails", { static: false })
  orderDetails!: OrderDetailsComponent;

  isMelissaValidationIgnore = false;

  constructor(
    private _fb: FormBuilder,
    private _saleOrderService: SaleOrderService,
    private _toastr: JniToastrService,
    private _route: Router,
    private _activeRoute: ActivatedRoute,
    private _loaderService: LoaderService,
    private _samplepoListingService: SamplepoListingService,
    private _addNewClientService: AddNewClientService,
    private _profileFormService: ProfileFormService,
    private _loginService: UserManagementService,
    private _clientDetailsService: ClientDetailsService,
    private _customerAccountService: CustomerAccountService,
    private _orderNotesSidebarService: OrderNotesSidebarService,
    private _programService: ProgramsService
  ) {
    this.initializeForm();
    const navigation = this._route.getCurrentNavigation();
    const qsOrderType = this._activeRoute.snapshot.queryParamMap.get("module");
    if (navigation?.extras?.state) {
      const state = navigation?.extras?.state as {
        accountNumber: string;
        buyer: string;
      };
      this.redirectedFromWorkflow = true;
      this.saleOrderForm.patchValue({
        orderHeader: {
          customerId: state.accountNumber,
          customerIdValid: state.accountNumber,
          buyer: state.buyer,
        },
      });
      if (this._route.getCurrentNavigation()?.extras?.state?.["orderType"]) {
        this.orderType =
          this._route.getCurrentNavigation()?.extras?.state?.["orderType"];
      }
    } else {
      this.orderType = qsOrderType ?? "";
    }

    this.saleOrderForm.patchValue({
      orderDetails: {
        jniSalesInventoryD365: this.orderType === "inventory-sales",
      },
    });
  }

  formErrors: Record<string, string> = {
    jobName: "",
    brandingConsultant: "",
    methodOfPaymentHeader: "",
    customerIdValid: "",
    shipDate: "",
    inHandsDate: "",
    addressSelectionName: "",
    countryRegionIdD365: "",
    customerPONumber: "",
    deliveryNameD365: "",
    store: "",
    warehouse: "",
  };

  validationMessages: Record<string, Record<string, string>> = {
    jobName: {
      required: "Job name is required.",
      minlength: "Job name must be greater than 2 characters.",
      maxlength: "Job name must be less than 300 characters.",
    },
    brandingConsultant: {
      required: "Branding consultant is required.",
      minlength: "Job name must be greater than 2 characters.",
      maxlength: "Job name must be less than 50 characters.",
    },
    accountsCoordinator: {
      required: "Accounts coordinator is required.",
    },
    methodOfPayment: {
      required: "Payment method is required.",
    },
    methodOfPaymentHeader: {
      required: "Payment method is required.",
    },
    customerIdValid: {
      required: "Client account is required.",
    },
    shipDate: {
      required: "Ship date is required.",
    },
    inHandsDate: {
      required: "In-Hands date is required.",
    },
    addressSelectionName: {
      required: "Delivery is required.",
    },
    countryRegionIdD365: {
      required: "Country is required.",
    },
    customerPONumber: {
      required: "Client PO Number is required.",
    },
    deliveryNameD365: {
      maxlength: "Name must be less than 100 characters.",
    },
    store: {
      required: "Store is required.",
    },
    warehouse: {
      required: "Warehouse is required.",
    },
  };

  ngOnInit(): void {
    this.disabledCustomerField();
    this.getCurrencyListData();
    this.getAllShippingMethod();
    this.getCountryRegionListData();
    this.getMehtodPaymentListData();
    this.getUserProfile();
  }

  logValidationErrors(group: FormGroup = this.saleOrderForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = "";
        if (
          abstractControl &&
          !abstractControl.valid &&
          (abstractControl.touched || abstractControl.dirty)
        ) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey && messages) {
              this.formErrors[key] += messages[errorKey] + " ";
            }
          }
        }
      }
    });
  }

  submitButtonlogValidationErrors(group: FormGroup = this.saleOrderForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.submitButtonlogValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = "";
        if (abstractControl && !abstractControl.valid) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey && messages) {
              this.formErrors[key] += messages[errorKey] + " ";
            }
          }
        }
      }
    });
  }

  private initializeForm() {
    this.saleOrderForm = this._fb.group({
      orderHeader: this._fb.group({
        customerId: ["", Validators.required],
        customerIdValid: ["", Validators.required],
        jobName: [
          "",
          [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(300),
          ],
        ],
        inHandsDate: ["", Validators.required], //inhands
        shipDate: [""],
        methodOfPaymentHeader: ["", Validators.required],
        brandingConsultant: [
          "",
          [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(50),
          ],
        ],
        accountsCoordinator: ["", Validators.required], // account co-ordinator
        buyer: [""],
        programId: [""],
        programDimensions: [""],
      }),
      customerAddress: this._fb.group({
        name: [""],
        address: [""],
        telephone: [""],
        billingLocationD365: [""],
        billingAttentionD365: [""],
      }),
      shipTo: this._fb.group({
        deliveryAddress: [""],
        attention: [""],
        countryRegionIdD365: ["", Validators.required],
        zipCodeD365: [""],
        cityD365: [""],
        stateD365: [""],
        addressD365: [""],
        streetD365: ["", Validators.required],
        purposeD365: [""],
        isPrimaryD365: "1",
        rSMJNIShipToEmailD365: [""],
        addressBook: [""],
        buildingComplimentD365: [""],
        apartment_RUD365: [""],
        postBoxD365: [""],
        countyD365: [""],
        streetNumberD365: [""],
        districtNameD365: [""],
        saveAddress: [false],
        attentionInformationD365: [""],
        siteD365: [""],
        addressSelectionName: ["", Validators.required],
        locationD365: [""],
        addressLocationNumber: 0,
        validateAddress: [""],
        addressFormat: [""],
        melissaAddressKeyD365: [""],
        addressLine1: [""],
        addressLine2: [""],
        addressLine3: [""],
        deliveryNameD365: ["", Validators.maxLength(100)],
      }),
      orderDetails: this._fb.group({
        // buyer: [''],
        shippingMethod: [""],
        foreignCurrency: ["USD"],
        customerPONumber: [""],
        shippingMethodName: [""],
        methodOfPayment: [""],
        creditCardFeeCharge: 0,
        foreignCurrencyStatus: [false],
        jniSalesInventoryD365: [{ value: false, disabled: true }],
        store: [""],
        warehouse: [""],
        site: [{ value: "", disabled: true }],
        owner: [{ value: "", disabled: true }],
        account: [""],
      }),
      invoicedEmails: this._fb.array([]),
    });
  }

  createInvoiceEmail(invoicedEmail: InvoicedEmailDto) {
    return this._fb.group({
      electronicAddressIdD365:
        invoicedEmail.electronicAddressIdD365 || uuidv4(),
      name: invoicedEmail.name || "",
      purpose: invoicedEmail.purpose || "",
      email: invoicedEmail.email || "",
      confirmation: invoicedEmail.confirmation,
      exist: invoicedEmail.exist,
      invoiced: invoicedEmail.invoiced,
      save: invoicedEmail.save,
    } as InvoicedEmailDto);
  }

  addInvoiceEmail(
    invoicedEmail: InvoicedEmailDto = {
      electronicAddressIdD365: uuidv4(),
      exist: false,
      invoiced: false,
      save: false,
      confirmation: false,
      email: "",
      name: "",
      purpose: "",
    }
  ) {
    const control = this.saleOrderForm.get("invoicedEmails") as FormArray;
    control.push(this.createInvoiceEmail(invoicedEmail));
    this.disableExisitInvoiceEmail();
  }

  clearShipAddressForm() {
    this.shipTo.clearNewShifToForm();
  }

  getLoaderStatus(status: boolean) {
    this.showSmallLoader = status;
  }

  addNewLine(event: boolean) {
    if (event) {
      const invoicedEmail: InvoicedEmailDto = {
        electronicAddressIdD365: uuidv4(),
        exist: false,
        invoiced: false,
        save: false,
        confirmation: false,
        email: "",
        name: "",
        purpose: "",
      };
      const control = this.saleOrderForm.get("invoicedEmails") as FormArray;
      control.insert(0, this.createInvoiceEmail(invoicedEmail));
      this.disableExisitInvoiceEmail();
      // this.addInvoiceEmail();
    }
  }
  removeEmail(formgroup: FormGroup[]) {
    formgroup.forEach(x => {
      const value = x.get("electronicAddressIdD365")?.value;
      for (
        let i = 0;
        i < (this.saleOrderForm.get("invoicedEmails") as FormArray).length;
        i++
      ) {
        if (
          (this.saleOrderForm.get("invoicedEmails") as FormArray)
            .at(i)
            .get("electronicAddressIdD365")?.value == value
        ) {
          (this.saleOrderForm.get("invoicedEmails") as FormArray).removeAt(i--);
        }
      }
    });
  }

  disabledCustomerField() {
    this.saleOrderForm.get(["customerAddress", "name"])?.disable();
    this.saleOrderForm.get(["customerAddress", "address"])?.disable();
    this.saleOrderForm.get(["customerAddress", "telephone"])?.disable();
    this.saleOrderForm
      .get(["customerAddress", "billingAttentionD365"])
      ?.disable();
    this.saleOrderForm
      .get(["customerAddress", "billingLocationD365"])
      ?.disable();
    this.saleOrderForm.get(["orderDetails", "foreignCurrency"])?.disable();
    this.saleOrderForm.get(["orderDetails", "shippingMethodName"])?.disable();
  }

  getAllBcUsers() {
    this._samplepoListingService
      .getAllBrandingConsultant()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<GetUserProjectDto[]>) => {
          if (res.data != null) {
            this.brandingConsultantLists = res.data;
            if (this.brandingConsultantLists) {
              if (this.brandingConsultantLists.length > 0) {
                this.brandingConsultantObject = this.brandingConsultantLists[0];
                this.patchValueInBrandingConsultant(
                  this.brandingConsultantLists[0]
                );
                this.getBACList(res.data[0].id);
              }
            }
          }
          this.showSmallLoader = false;
          //this.shipTo.onDeliveryAddressChange('One Time');
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  patchValueInBrandingConsultant(data: string | GetBCForSalesOrderDto) {
    this.saleOrderForm.patchValue({
      orderHeader: {
        brandingConsultant: data,
      },
    });
  }

  getBACList(id: number) {
    this._addNewClientService
      .getBACList(id)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<UsersList[]>) => {
          this.bacList = res.data.map((obj: UsersList) => {
            const bac = {
              personnelNumber: obj.personnelNumber,
              projectId: obj.projectId,
              name: obj.name,
              projectName: obj.name,
              isPrimary: obj.isPrimary,
            } as GetBacForSalesOrderDto;
            return bac;
          }) as GetBacForSalesOrderDto[];
          // const obj = this.bacList.filter((x) => x.isPrimary == true);
          // if (obj.length > 0) {
          //   this.bacUserDefaultSelectionId = obj[0].personnelNumber;
          // }
        },
      });
  }

  getCurrencyListData() {
    this._addNewClientService
      .getCurrencyList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.currencyList = res.data;
        },
      });
  }

  getMehtodPaymentListData() {
    const params = "?";
    this._saleOrderService
      .getMethodPaymentList(params)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.customerPaymentMethodList = res.data;
        },
      });
  }

  getAllShippingMethod() {
    this._samplepoListingService
      .getAllShippingMethod()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          const shippingData = res.data;
          // this.shippingProductsList = shippingData.filter(
          //   (x) => x.jniUseOnSalesOrderD365 !== 'No'
          // );
          this.shippingProductsList = shippingData;
        },
      });
  }

  getCountryRegionListData() {
    this._addNewClientService
      .getCountryRegionList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.countryRegionList = res?.data;
        },
      });
  }

  buyerChangeEvent() {
    this.getAllContactsByAccountNumber(
      this.customerBillToObject?.clientAccount,
      this.customerBillToObject?.partyNumber
    );
  }

  getCustomerBillToData(clientObj: ClientSearchList) {
    this.customerBillToObject = clientObj;
    this.getAllContactsByAccountNumber(
      this.customerBillToObject?.clientAccount,
      this.customerBillToObject?.partyNumber
    );
    this.getShippingMethodByCustomer(clientObj);
    this.getBCForSalesOrder(
      clientObj.clientAccount,
      clientObj.bcPersonnelNumberD365 ?? ""
    );
    this.getAvailableCredit(this.customerBillToObject?.clientAccount);
    const delivery = this.saleOrderForm.get([
      "shipTo",
      "addressSelectionName",
    ])?.value;
    if (
      delivery === "Bill To" ||
      delivery === "Bill to" ||
      delivery === "Client Address Book" ||
      delivery === "Client address book" ||
      delivery == "Address book" ||
      delivery == "To address book"
    ) {
      this.shipTo.clearNewShifToForm();
    }
    this.isCustomerPOFieldRequired(this.customerBillToObject?.clientAccount);
  }

  getBCForSalesOrder(accountNumber: string, bcNumber: string) {
    this._saleOrderService
      .getBCForSalesOrder(accountNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data != null) {
            this.brandingConsultantLists = res.data;

            const filterBcObject = this.brandingConsultantLists.filter(
              x => x.personnelNumber === bcNumber
            );
            if (filterBcObject.length > 0) {
              this.patchValueInBrandingConsultant(
                filterBcObject[0].projectName
              );
            } else {
              if (this.brandingConsultantLists.length > 0) {
                this.patchValueInBrandingConsultant(
                  this.brandingConsultantLists[0].projectName
                );
              } else {
                this.patchValueInBrandingConsultant("");
              }
            }
            this.getBacForSalesOrder(filterBcObject[0]?.personnelNumber);
          }
        },
      });
  }

  getBacForSalesOrder(personnelNumber: string) {
    this._saleOrderService
      .getBacForSalesOrder(personnelNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data != null) {
            this.bacList = res.data;
            // const filterBacObject = res.data.filter(
            //   (x) => x.personnelNumber === this.userPersonnelNumber
            // );

            if (this.bacList.length > 0) {
              const obj = this.bacList.find(x => x.isPrimary);
              if (obj) {
                this.bacUserDefaultSelectionId = obj?.personnelNumber || "";
              }
              if (!this.bacUserDefaultSelectionId) {
                this.bacUserDefaultSelectionId =
                  this.bacList[0].personnelNumber;
              }
            } else {
              this.bacUserDefaultSelectionId = "";
            }

            this.patchValueInBacField(this.bacUserDefaultSelectionId);

            // if (filterBacObject.length > 0) {
            //   this.bacUserDefaultSelectionId =
            //     filterBacObject[0].personnelNumber;
            //   this.patchValueInBacField(this.bacUserDefaultSelectionId);
            // } else {
            //   if (this.bacList.length > 0) {
            //     this.bacUserDefaultSelectionId =
            //       this.bacList[0].personnelNumber;
            //     this.patchValueInBacField(this.bacUserDefaultSelectionId);
            //   } else {
            //     this.bacUserDefaultSelectionId = '';
            //   }
            // }
          }
        },
      });
  }

  patchValueInBacField(personnelNumber: string) {
    this.saleOrderForm.patchValue({
      orderHeader: {
        accountsCoordinator: personnelNumber,
      },
    });
  }

  getUserProfile() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.getUserById(res?.data?.userId);
      });
  }

  getUserById(userId: number) {
    this._profileFormService.getUsersById(userId).subscribe({
      next: async res => {
        if (res.data != null) {
          this.userPersonnelNumber = res.data.personnelNumber;
        }
      },
    });
  }

  getShippingMethodByCustomer(clientObj: ClientSearchList) {
    if (clientObj) {
      const shippingobj = this.shippingProductsList.filter(
        x => x.modeCodeD365 === clientObj.shippingMethod
      );
      if (shippingobj.length > 0) {
        this.patchValueInShippingMethod(shippingobj[0]);
      }
    }
  }

  patchValueInShippingMethod(shippingobj: ShippingMethod) {
    this.saleOrderForm.patchValue({
      orderDetails: {
        shippingMethod: shippingobj.modeCodeD365,
        shippingMethodName: shippingobj.modeDescriptionD365,
        account:
          shippingobj.useFreightAccountD365?.toLowerCase() === "yes"
            ? shippingobj.jniFreightAcctNumD365
            : "",
      },
    });
  }

  getAllContactsByAccountNumber(accountNumber: string, partyNumber = "") {
    this.showSmallLoader = true;
    this._saleOrderService
      .getAllContactsByAccountNumber(accountNumber, partyNumber)
      .pipe(map(value => value.data))
      .subscribe({
        next: (data: Contact[]) => {
          this.showSmallLoader = false;
          const sortedData = data.sort((a, b) => {
            const dateA = a.createdDate ? new Date(a.createdDate) : new Date(0);
            const dateB = b.createdDate ? new Date(b.createdDate) : new Date(0);
            return dateB.getTime() - dateA.getTime();
          });
          this.clientContacts = sortedData;
          const invoicedEmails = sortedData?.filter(
            x =>
              // 11313 - Create new order and select customer in it. Remove the check or pulling only emails with the purpose invoice when creating an order header in the portal
              // x.purposeD365?.toLowerCase() == 'invoice' &&
              x.typeD365?.toLowerCase() == "email"
          );

          const filteredInvoicedEmails = invoicedEmails.filter(
            (email, index) =>
              index ===
              invoicedEmails.findIndex(
                secondEmail => email.locatorD365 === secondEmail.locatorD365
              )
          );

          const control = this.saleOrderForm.get("invoicedEmails") as FormArray;
          control.clear();

          filteredInvoicedEmails.forEach(x => {
            this.addInvoiceEmail({
              electronicAddressIdD365: x.electronicAddressIdD365 ?? uuidv4(),
              name: x.descriptionD365 ?? "",
              purpose: x.purposeD365 ?? "",
              email: x.locatorD365 ?? "",
              exist: true,
              invoiced: false,
              confirmation: false,
              save: true,
            });
          });
          this.disableSaveAndExisitInvoiceEmail();
          this.transformClientContactData();
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  ClientAddresses: ClientAddressCustomize[] = [];

  transformClientContactData() {
    this.ClientAddresses = [];
    // this.saleOrderForm.patchValue({
    //   orderDetails: {
    //     buyer: ''
    //   }
    // });
    // const Business = this.clientContacts?.filter(
    //   (x) => x.purposeD365 == ClientPurposeType.Business
    // );
    // this.populateClientContactInformation(Business);
    // const Invoice = this.clientContacts?.filter(
    //   (x) => x.purposeD365 == ClientPurposeType.Invoice
    // );
    // this.populateClientContactInformation(Invoice);
    // const Payment = this.clientContacts?.filter(
    //   (x) => x.purposeD365 == ClientPurposeType.Payment
    // );
    // this.populateClientContactInformation(Payment);
    // const Delivery = this.clientContacts?.filter(
    //   (x) => x.purposeD365 == ClientPurposeType.Delivery
    // );
    // this.populateClientContactInformation(Delivery);
    // const Other = this.clientContacts?.filter(
    //   (x) => x.purposeD365 == ClientPurposeType.Other
    // );
    // this.populateClientContactInformation(Other);
    // const Buyer = this.clientContacts?.filter(
    //   (x) => x.purposeD365 == ClientPurposeType.Buyer
    // );
    this.populateClientContactInformation(this.clientContacts);
  }

  populateClientContactInformation(
    clientContacts: ClientContact[] | undefined
  ) {
    if (
      clientContacts != null &&
      clientContacts != undefined &&
      clientContacts.length > 0
    ) {
      clientContacts.forEach(element => {
        if (element?.locatorD365) {
          const clientAddress: ClientAddressCustomize = {};
          clientAddress.purpose = element.purposeD365;
          clientAddress.isPrimary = element.isPrimaryD365;
          clientAddress.name = element.descriptionD365;
          clientAddress.cust = element.cust;
          clientAddress.title = element.title;
          clientAddress.electronicAddressIdD365 =
            element.electronicAddressIdD365;

          if (element.typeD365 == EnumContactType.Phone) {
            clientAddress.phone = element.locatorD365;
            clientAddress.phoneLink = "tel:'" + element.locatorD365 + "'";
          } else if (element.typeD365 == EnumContactType.Email) {
            clientAddress.email = element.locatorD365;
            clientAddress.emailLink = "mailto:'" + element.locatorD365 + "'";
          }
          if (clientAddress.name) {
            this.ClientAddresses.push(clientAddress);
          }
        }
      });
    }
  }

  private disableSaveAndExisitInvoiceEmail() {
    (this.saleOrderForm.get("invoicedEmails") as FormArray).controls.forEach(
      group => {
        (group.get("save") as FormControl).disable();
        (group.get("exist") as FormControl).disable();
      }
    );
  }
  private disableExisitInvoiceEmail() {
    (this.saleOrderForm.get("invoicedEmails") as FormArray).controls.forEach(
      group => {
        (group.get("exist") as FormControl).disable();
      }
    );
  }

  isEmailInvoiced(): boolean {
    const control = this.saleOrderForm.get("invoicedEmails") as FormArray;
    for (let i = 0; i < control.length; i++) {
      if ((control.at(i) as FormGroup).get("invoiced")?.value) {
        return true;
      }
    }
    return false;
  }

  isEmailInvoicedEmpty(): boolean {
    const control = this.saleOrderForm.get("invoicedEmails") as FormArray;
    for (let i = 0; i < control.length; i++) {
      if ((control.at(i) as FormGroup).get("invoiced")?.value) {
        const email = (control.at(i) as FormGroup).get("email")?.value;
        if (!email) {
          return true;
        }
      }
    }
    return false;
  }

  isEmailValid(): boolean {
    let isEmail = true;
    const control = this.saleOrderForm.get("invoicedEmails") as FormArray;
    for (let i = 0; i < control.length; i++) {
      if ((control.at(i) as FormGroup).get("invoiced")?.value) {
        const email: string = (control.at(i) as FormGroup).get("email")?.value;
        const regex = `^[a-zA-Z0-9._%+-]+(?:'[a-zA-Z0-9._%+-]+)?@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$`;
        if (!RegExp(regex).exec(email)) {
          isEmail = false;
        }
      }
    }
    if (isEmail) {
      return true;
    }
    return false;
  }

  isEmailDuplicate(): boolean {
    const control = this.saleOrderForm.get("invoicedEmails") as FormArray;
    const emailSet = new Set();
    for (let i = 0; i < control.length; i++) {
      emailSet.add((control.at(i) as FormGroup).get("email")?.value);
    }
    return control.length != emailSet.size;
  }

  EmailDuplicate(): boolean {
    const control = this.saleOrderForm.get("invoicedEmails") as FormArray;
    for (let i = 0; i < control.length; i++) {
      const email = (control.at(i) as FormGroup).get("email")?.value;
      for (let j = i + 1; j < control.length; j++) {
        if (email == (control.at(j) as FormGroup).get("email")?.value) {
          this._toastr.error(
            "Error",
            `Email address "${email}". The record already exists.`
          );
          return true;
        }
      }
    }
    return false;
  }

  private validateFormFields(): boolean {
    // Get all form controls
    const orderHeader = this.saleOrderForm.get("orderHeader");
    const shipTo = this.saleOrderForm.get("shipTo");
    const orderDetails = this.saleOrderForm.get("orderDetails");

    let isValid = true;

    // Validate Order Header
    if (orderHeader?.invalid) {
      if (orderHeader.get("customerId")?.invalid) {
        this._toastr.error("Error", "Client account is required");
        isValid = false;
      }
      if (orderHeader.get("jobName")?.invalid) {
        this._toastr.error(
          "Error",
          "Job name is required and must be between 2-300 characters"
        );
        isValid = false;
      }
      if (orderHeader.get("inHandsDate")?.invalid) {
        this._toastr.error("Error", "In-Hands date is required");
        isValid = false;
      }
      if (orderHeader.get("brandingConsultant")?.invalid) {
        this._toastr.error("Error", "Branding consultant is required");
        isValid = false;
      }
      if (orderHeader.get("accountsCoordinator")?.invalid) {
        this._toastr.error("Error", "Accounts coordinator is required");
        isValid = false;
      }
    }

    // Validate Ship To
    if (shipTo?.invalid) {
      if (shipTo.get("addressSelectionName")?.invalid) {
        this._toastr.error("Error", "Delivery selection is required");
        isValid = false;
      }
      if (shipTo.get("countryRegionIdD365")?.invalid) {
        this._toastr.error("Error", "Country is required");
        isValid = false;
      }
      if (
        shipTo.get("streetD365")?.invalid &&
        !this.isMelissaValidationIgnore
      ) {
        this._toastr.error("Error", "Street address is required");
        isValid = false;
      }
    }

    // Validate Order Details
    if (orderDetails?.invalid) {
      if (
        this.isCustomerPoRequiredField &&
        orderDetails.get("customerPONumber")?.invalid
      ) {
        this._toastr.error("Error", "Customer PO Number is required");
        isValid = false;
      }
    }

    // Validate Invoice Emails
    // if (!this.isEmailValid()) {
    //   this._toastr.error('Error', 'Invalid email format in invoice emails');
    //   isValid = false;
    // }

    // if (!this.isEmailInvoiced()) {
    //   this._toastr.error('Error', 'At least one email must be marked for invoice');
    //   isValid = false;
    // }

    // if (this.isEmailInvoicedEmpty()) {
    //   this._toastr.error('Error', 'Invoice email cannot be empty');
    //   isValid = false;
    // }

    // if (this.EmailDuplicate()) {
    //   this._toastr.error('Error', 'Duplicate emails are not allowed');
    //   isValid = false;
    // }

    return isValid;
  }

  onSubmit() {
    this.submitButtonlogValidationErrors();
    if (!this.isEmailValid()) {
      this._toastr.error(
        "Error",
        "In invoice emails a valid email address is required"
      );
      return;
    }

    if (!this.isEmailInvoiced()) {
      this._toastr.error("Error", "Atleast one valid email should be invoiced");
      return;
    }

    if (this.isEmailInvoicedEmpty()) {
      this._toastr.error("Error", "Invoiced email should not empty");
      return;
    }

    if (this.EmailDuplicate()) {
      return;
    }
    const saleOrderFormObject =
      this.saleOrderForm.getRawValue() as CreateSalesOrderRequestDto;

    if (
      this.getD365DefaultProgramsAndSalesClassification.d365DefaultPrgram &&
      saleOrderFormObject.orderHeader &&
      (saleOrderFormObject.orderHeader.programId === 0 ||
        !saleOrderFormObject.orderHeader.programDimensions ||
        saleOrderFormObject.orderHeader.programDimensions?.length <= 0)
    ) {
      this._toastr.error(
        "Error",
        `Missing portal-configured program for the client ${saleOrderFormObject.orderHeader.customerId}`
      );
      return;
    }
    this._loaderService.setLoaderState(true);

    // if (!saleOrderFormObject['shipTo']?.streetD365) {
    //   if (
    //     saleOrderFormObject['shipTo']?.addressSelectionName?.toLowerCase() !==
    //       'tbd' &&
    //     !(
    //       saleOrderFormObject['shipTo']?.addressSelectionName?.toLowerCase() ==
    //         'multi ship to' ||
    //       saleOrderFormObject['shipTo']?.addressSelectionName?.toLowerCase() ==
    //         'multiple ship-to' ||
    //       saleOrderFormObject['shipTo']?.addressSelectionName
    //         ?.toLowerCase()
    //         .includes('drop')
    //     )
    //   ) {
    //     this._toastr.error('Error', 'Address is required');
    //     this._loaderService.setLoaderState(false);
    //     return;
    //   }
    // }

    if (
      saleOrderFormObject.orderHeader &&
      !saleOrderFormObject.orderHeader.shipDate
    ) {
      saleOrderFormObject.orderHeader.shipDate = "";
    }

    // if (
    //   saleOrderFormObject['orderHeader'] &&
    //   !saleOrderFormObject['orderHeader'].inHandsDate
    // ) {
    //   saleOrderFormObject['orderHeader'].inHandsDate = '';
    // }

    if (
      saleOrderFormObject.orderHeader?.shipDate &&
      saleOrderFormObject.orderHeader?.inHandsDate
    ) {
      if (
        new Date(saleOrderFormObject.orderHeader?.inHandsDate) <
        new Date(saleOrderFormObject.orderHeader?.shipDate)
      ) {
        this._loaderService.setLoaderState(false);
        this._toastr.error(
          "Error",
          "Inhands date header greater and equal to ship date header"
        );
        return;
      }
    }

    if (saleOrderFormObject.orderHeader?.brandingConsultant) {
      const bcObject = this.brandingConsultantLists.filter(
        x =>
          x.projectName === saleOrderFormObject.orderHeader?.brandingConsultant
      );
      saleOrderFormObject.orderHeader.brandingConsultant =
        bcObject[0].personnelNumber;
    }

    if (
      saleOrderFormObject.shipTo &&
      saleOrderFormObject.shipTo.addressLocationNumber === 0
    ) {
      saleOrderFormObject.shipTo.addressLocationNumber = 0;
    }

    if (
      saleOrderFormObject.shipTo?.addressSelectionName
        ?.toLowerCase()
        .includes("one")
    ) {
      saleOrderFormObject.shipTo.addressLocationNumber = 0;
    }

    // if (!this.saleOrderForm.get(['shipTo', 'validateAddress'])?.valid) {
    //   this._loaderService.setLoaderState(false);
    //   this._toastr.error('Error', 'Please validate the address');
    //   return;
    // }

    if (saleOrderFormObject.shipTo) {
      const formValue = this.saleOrderForm.getRawValue();
      const value = formValue.shipTo.shipToVendorAccountNameD365 || "";
      saleOrderFormObject.shipTo.deliveryAddressD365 = this.getDeliveryAddress(
        saleOrderFormObject.shipTo.addressSelectionName ?? "",
        saleOrderFormObject.shipTo.deliveryNameD365 ?? "",
        value ?? ""
      );

      saleOrderFormObject.shipTo.shipToD365Address =
        formValue.shipTo.addressD365 ?? "";
    }

    if (saleOrderFormObject.orderDetails && saleOrderFormObject.orderHeader) {
      saleOrderFormObject.orderDetails.buyer =
        saleOrderFormObject.orderHeader.buyer;
    }

    if (this.isMelissaValidationIgnore) {
      this.saleOrderForm.get(["shipTo", "streetD365"])?.clearValidators();
      this.saleOrderForm
        .get(["shipTo", "streetD365"])
        ?.updateValueAndValidity();
    }

    if (!this.saleOrderForm.valid) {
      if (!this.validateFormFields()) {
        this._loaderService.setLoaderState(false);
        return;
      }
      this._loaderService.setLoaderState(false);
      return;
    }

    if (
      saleOrderFormObject.orderDetails !== null &&
      saleOrderFormObject.orderHeader !== null
    ) {
      saleOrderFormObject.orderDetails.methodOfPayment =
        saleOrderFormObject.orderHeader?.methodOfPaymentHeader;
    }

    if (
      saleOrderFormObject?.orderHeader !== null &&
      !saleOrderFormObject?.orderHeader?.programDimensions
    ) {
      saleOrderFormObject.orderHeader.programDimensions = null;
    }

    if (saleOrderFormObject.invoicedEmails) {
      saleOrderFormObject.invoicedEmails.forEach((x: InvoicedEmailDto) => {
        if (x.save === undefined || !x.save) {
          x.save = false;
        }
        if (x.exist === undefined || !x.exist) {
          x.exist = false;
        }
        if (x.confirmation === undefined || !x.confirmation) {
          x.confirmation = false;
        }
      });
    }

    if (saleOrderFormObject?.orderDetails) {
      saleOrderFormObject.orderDetails.foreignCurrencyStatus =
        saleOrderFormObject.orderDetails.foreignCurrency !== "USD";
    }

    this._saleOrderService
      .addSaleOrderHeaderData(saleOrderFormObject)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.status.toLowerCase() == "success") {
            if (res?.data?.SalesOrderId) {
              if (this.isMelissaValidationIgnore) {
                this.onSaleOrderNotesSave(res.data.SalesOrderId);
              } else {
                this._toastr.success(
                  "Success",
                  res.message || "Sale order added successfully"
                );
                let state = {} as NavigationExtras;
                state = {
                  state: {
                    orderType: this.orderType,
                    addNewLineCase: true,
                  },
                } as NavigationExtras;
                const url = `/orders/order-line-item/${res.data.SalesOrderId}`;
                this._route.navigate([url], state);
              }
            } else {
              this._toastr.error(
                "Error",
                "Invalid Sales Order Id From Dyanmics."
              );
            }
          } else {
            this._toastr.error(
              "Error",
              res.message || "Error adding sale order"
            );
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message || "Error adding sale order");
        },
      });
  }

  getAvailableCredit(accountNumber: string) {
    this._clientDetailsService
      .getAvailableCredit(accountNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.status.toLowerCase() != "success") {
            this.avaiableCredit = 0;
            this._toastr.error(res.message, "Error");
          } else {
            this.avaiableCredit = res?.data?.availableCredit;
          }
        },
        error: (res: { message: string }) => {
          this.avaiableCredit = 0;
          this._toastr.error(res.message, "Error");
          this._loaderService.setLoaderState(false);
        },
      });
  }

  getDeliveryAddress(
    addressSelectionName: string,
    deliveryNameD365: string,
    shipToVendorAccountNameD365: string
  ) {
    if (addressSelectionName.toLowerCase().includes("one")) {
      return deliveryNameD365;
    } else if (addressSelectionName.toLowerCase().includes("bill")) {
      return deliveryNameD365;
    } else if (addressSelectionName.toLowerCase().includes("vendor")) {
      return shipToVendorAccountNameD365;
    } else if (addressSelectionName.toLowerCase().includes("address")) {
      return deliveryNameD365;
    } else if (addressSelectionName.toLowerCase().includes("branding")) {
      return deliveryNameD365;
    }
    return "";
  }

  isCustomerPOFieldRequired(accountNumber: string) {
    this._clientDetailsService
      .IsCustomerPOFieldRequired(accountNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data) {
            this.setCustomerPoRequiredField();
          } else {
            this.removeCustomerPoRequiredField();
          }
        },
        error: (res: { message: string }) => {
          this._toastr.error(res.message, "Error");
        },
      });
  }

  setCustomerPoRequiredField() {
    this.isCustomerPoRequiredField = true;
    this.saleOrderForm
      .get(["orderDetails", "customerPONumber"])
      ?.setValidators(Validators.required);
    this.saleOrderForm
      .get(["orderDetails", "customerPONumber"])
      ?.updateValueAndValidity();
  }

  removeCustomerPoRequiredField() {
    this.isCustomerPoRequiredField = false;
    this.saleOrderForm
      .get(["orderDetails", "customerPONumber"])
      ?.clearValidators();
    this.saleOrderForm
      .get(["orderDetails", "customerPONumber"])
      ?.updateValueAndValidity();
  }

  contactListRefreshGrid(obj: boolean) {
    if (obj) {
      this.getCustomerBillToData(this.customerBillToObject);
    }
  }

  handleMelissaValidationIgnore(value: boolean) {
    this.isMelissaValidationIgnore = value;
  }

  onSaleOrderNotesSave(saleOrderId: string) {
    this._loaderService.setLoaderState(true);
    const saleOrderFormObject =
      this.saleOrderForm.getRawValue() as SalesOrderNotes;
    if (saleOrderId) {
      saleOrderFormObject.salesOrderId = saleOrderId;
      saleOrderFormObject.portalKey = uuidv4();
      saleOrderFormObject.description = "System Order # " + saleOrderId;
      saleOrderFormObject.id = 0;
      saleOrderFormObject.note = "Non approved address was accepted";
      saleOrderFormObject.portalKey = uuidv4();
      saleOrderFormObject.purchaseOrderStatus = false;
      saleOrderFormObject.salesOrderId = saleOrderId;
      saleOrderFormObject.type = "Order note";
    }
    this._orderNotesSidebarService
      .AddSalesOrderNotes(saleOrderFormObject)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this._toastr.success(
              "Success",
              res.message ?? "Sale order added successfully with Order Note"
            );
            let state = {} as NavigationExtras;
            state = {
              state: {
                orderType: this.orderType,
              },
            } as NavigationExtras;
            const url = `/orders/order-line-item/${saleOrderId}`;
            this._route.navigate([url], state);
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message ?? "Error adding order note");
        },
      });
  }

  getProgramDetails($event: ProgramClientListDto) {
    this.saleOrderForm.patchValue({
      orderHeader: {
        programId: $event.programId,
      },
    });

    if ($event.dimensionD365 && $event.dimensionD365 !== "") {
      this.saleOrderForm.patchValue({
        orderHeader: {
          programDimensions: [
            {
              displayValue: $event.dimensionD365,
              displayName: $event.dimensionNameD365,
            },
          ],
        },
      });
    } else {
      this.saleOrderForm.patchValue({
        programDimensions: [],
      });
    }

    const customerId = this.saleOrderForm.get([
      "orderHeader",
      "customerIdValid",
    ])?.value;
    if ($event.clientAccount !== customerId) {
      this.showSmallLoader = true;
      this._customerAccountService
        .getCustomerByNameAndAccountNumberFilter($event.clientAccount)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.saleOrderForm.get(["orderHeader", "buyer"])?.disable();
            const customerLists = res.data;
            if (customerLists.length > 0) {
              this.orderHeader.getCustomerBillToData(customerLists[0]);
              this.orderHeader.customerAccount.customerBillToObject =
                customerLists[0];
              this.orderHeader.buyer.onClientSelection(customerLists[0]);
              this.saleOrderForm.patchValue({
                orderHeader: {
                  customerIdValid: customerLists[0].clientAccount,
                  customerId: customerLists[0].clientAccount,
                },
              });
              this.orderHeader.buyer.getAllBuyers();
              this.shipTo.customerBillToObject = customerLists[0];
              this.shipTo.patchAddressOfCustomerBillTo();
              this.shipTo.patchAddressOfCustomerAddressBook();
            }
            this.saleOrderForm.get(["orderHeader", "buyer"])?.enable();
            this.showSmallLoader = false;
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    }
  }

  customerAccountChangedEvent(customerAccount: string) {
    this._programService
      .getD365DefaultProgramsAndSalesClassificationByClient(customerAccount)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res?.status === "Success" && res?.data) {
            this.getD365DefaultProgramsAndSalesClassification = res.data;
          }
        },
      });
  }

  navigateToOrderListing() {
    if (this.orderType === "inventory-sales") {
      const nav = this._route.getCurrentNavigation();
      const currentState =
        (nav?.extras?.state as Record<string, unknown>) ?? {};
      this._route.navigate(["/orders/inventory-sales-listing"], {
        state: {
          ...currentState,
          orderType: this.orderType,
        },
        queryParamsHandling: "preserve",
        replaceUrl: false,
      });
    } else {
      this._route.navigate(["/orders/all-sales-listing"]);
    }
  }

  patchValueInCurrencyFieldEvent(currency: string) {
    this.orderDetails.patchValueInCurrency(currency);
  }
}
